import React from 'react';
import { Layout, Paragraph } from '@vwfs-bronson/bronson-react';
import './errorpage.scss';

export const ErrorPage = () => {
  return (
    <Layout center>
      <Layout.Item default="1/2" s="1/1">
        <div className="error-message">
          <Paragraph>404</Paragraph>
          <Paragraph>Diese Seite ist leider nicht verfügbar.</Paragraph>
        </div>
      </Layout.Item>
    </Layout>
  );
};
